import React from "react";
import { useField } from "formik";
import { useSelector } from "react-redux";
import { getBusinessById } from "selectors";
import { Row } from "components/Layout";
import { SubtleBadge } from "components/Badge";
import { CollapseLabel } from "components/Form";
import { pluralize } from "lib/pluralize";

interface EmailRecipientsHeaderProps {
  masterBusinessId: string;
  namespace: string;
  primaryContactEmail: string | null;
}

export function EmailRecipientsHeader(
  props: EmailRecipientsHeaderProps,
): React.JSX.Element {
  const { masterBusinessId, namespace: ns, primaryContactEmail } = props;
  const [{ value }] = useField<EmailRecipient[]>(ns);

  const numEmailRecipients = value.length;
  const numBusinessUsers = useSelector(
    (state: State) =>
      getBusinessById(masterBusinessId)(state)?.businessUsers.length || 0,
  );

  return (
    <Row>
      <SubtleBadge
        hasErrorBadge={numEmailRecipients === 0 || !primaryContactEmail}
      >
        Contacts
      </SubtleBadge>
      <Row alignCenter flexWrap>
        <CollapseLabel>
          {numEmailRecipients}&nbsp;
          {pluralize("Contact", numEmailRecipients)}
        </CollapseLabel>
        <CollapseLabel>
          {numBusinessUsers} AgriNous {pluralize("User", numBusinessUsers)}
        </CollapseLabel>
        <CollapseLabel>
          Primary Contact: {primaryContactEmail || "Not Set"}
        </CollapseLabel>
      </Row>
    </Row>
  );
}
